import shop from 'shopify-buy'

export default shop.buildClient({
  domain: 'grandarmy-store.myshopify.com',
  storefrontAccessToken: '9f3cff0370a124593f6564e6bee0dc34'
})
